module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=LT - Lithuania.2c58a1ca.svg";